@if (!online() && !dismissed()) {
    <a routerLink="/sync-status"
        class="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-1.5 rounded-full bg-amber-50 text-amber-700 border border-amber-200 pl-3 pr-2 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] shadow-sm print:hidden transition-all">
        <span class="w-1.5 h-1.5 rounded-full bg-amber-500"></span>
        Sin conexión
        <button type="button" (click)="dismiss($event)" title="Ocultar"
            class="ml-1 flex items-center justify-center w-3.5 h-3.5 rounded-full hover:bg-black/10 normal-case tracking-normal">
            <svg viewBox="0 0 24 24" class="w-2.5 h-2.5" fill="none" stroke="currentColor" stroke-width="3">
                <path stroke-linecap="round" d="M6 6l12 12M18 6L6 18" />
            </svg>
        </button>
    </a>
}
